import { Link } from 'react-router-dom';
import { useModuleAccess } from './access';
import { linkTarget, PARENT_KIND_LABEL, type ParentRef } from './parentRef';

interface Props {
  /** Reihenfolge = Anzeige; null und undefined werden übergangen */
  items: Array<ParentRef | null | undefined>;
  className?: string;
}

/**
 * Eltern eines Dokuments im Kopf (Regel „Dokument-Navigation" R1). Darf der Anwender das
 * Ziel nicht öffnen, erscheint der Name als Text.
 */
export function ParentLinks({ items, className = '' }: Props) {
  const access = useModuleAccess();
  const list = items.filter((p): p is ParentRef => p != null);
  if (list.length === 0) return null;

  return (
    <nav aria-label="Gehört zu" data-test-anchor="parents" className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-sm ${className}`}>
      {list.map((p) => {
        const to = linkTarget(p, access.has);
        return (
          <span key={`${p.kind}:${p.to ?? p.label}`} className="inline-flex items-baseline gap-1.5 min-w-0" data-parent-kind={p.kind}>
            <span className="text-slate-500 flex-shrink-0">{PARENT_KIND_LABEL[p.kind]}:</span>
            {to
              ? <Link to={to} className="text-brand-400 hover:text-brand-300 hover:underline truncate">{p.label}</Link>
              : <span className="text-slate-300 truncate">{p.label}</span>}
          </span>
        );
      })}
    </nav>
  );
}
